import React from 'react';
import { Card } from 'primereact/card';
import DescriptionBox from '../../../../components/descriptionBox/DescriptionBox';
import { CoachingTabs } from '../../../../utils/typeConstants';

interface FrameSectionProps {
    frameNotes: string;
    onFrameNotesChange: (value: string) => void;
}

export const FrameSection: React.FC<FrameSectionProps> = ({
    frameNotes,
    onFrameNotesChange
}) => {
    const exampleOpeningStatements = [
        '"Thanks for joining me today. How are things going for you right now?"',
        `"Let's start with where you're at right now. How have things been going lately?"`,
        '"This session is about you—your goals and challenges and what you\'d like to work through. Where would you like to start today?"',
        '"How have things been progressing since we last spoke? Any wins, challenges or updates you\'d like to share?"',
        '"I know things can get busy, so I really appreciate you being here. Let\'s take this time to pause and talk about how you are doing and how I can best support you."',
        '"We are here to have a conversation that supports your growth and clarity. What would be helpful for us to explore together today?"'
    ];

    return (
        <div className="fuel-section-content">
            <h4 className="section-title">Frame the Conversation</h4>
            <p className="section-subtitle">
                Start by building rapport and setting icebreakers
            </p>

            <Card className="examples-card">
                <h5>Example Opening Statements:</h5>
                <ul className="examples-list">
                    {exampleOpeningStatements.map((statement, index) => (
                        <li key={index}>{statement}</li>
                    ))}
                </ul>
            </Card>

            <div className="notes-section">
                <DescriptionBox
                    title='Frame Notes'
                    responseDescription={frameNotes}
                    value={frameNotes}
                    limit={4000}
                    onChange={(val: string) => onFrameNotesChange(val)}
                    via={CoachingTabs.CoachingActionPlan}
                />
            </div>
        </div>
    );
};
